import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { ScreenHeader, IconButton } from '../components/UI';
import Icon from '../components/Icon';
import { resetTutorial } from '../tutorial/TutorialProvider';

interface Section {
  title: string;
  steps: string[];
}

const SECTION_ICONS = ['wallet', 'arrow-up', 'plus', 'ticket-alt', 'users', 'arrow-down'];

export default function Help() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { colors } = useTheme();
  const sections = t('help.sections', { returnObjects: true }) as Section[];

  const replay = () => {
    resetTutorial();
    navigate('/home');
  };

  return (
    <div style={{ minHeight: '100dvh', backgroundColor: colors.bg }}>
      <ScreenHeader
        title={t('help.title')}
        icon="book-open"
        right={<IconButton icon="arrow-left" accessibilityLabel={t('help.back')} onPress={() => navigate(-1)} />}
      />
      <div style={{ padding: 20, paddingBottom: 40 }}>
        <div style={{ fontSize: 14, color: colors.textSub, marginBottom: 18, lineHeight: 1.55 }}>
          {t('help.intro')}
        </div>

        {sections.map((section, idx) => (
          <div
            key={idx}
            style={{
              borderRadius: 14, border: `1px solid ${colors.cardBorder}`,
              backgroundColor: colors.card, marginBottom: 12, padding: 16,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{
                width: 38, height: 38, borderRadius: 10,
                backgroundColor: colors.accentSoft,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>
                <Icon name={SECTION_ICONS[idx]} size={16} color={colors.accentText} />
              </div>
              <div style={{ fontSize: 15, fontWeight: 800, color: colors.text }}>{section.title}</div>
            </div>
            <ol style={{ margin: 0, padding: '0 0 0 20px', color: colors.textSub, fontSize: 14, lineHeight: 1.6 }}>
              {section.steps.map((step, i) => (
                <li key={i} style={{ marginBottom: 6 }}>{step}</li>
              ))}
            </ol>
          </div>
        ))}

        <button
          onClick={replay}
          style={{
            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            padding: 14, borderRadius: 14, marginTop: 8, minHeight: 52,
            backgroundColor: colors.accent, color: '#020617',
            border: 'none', cursor: 'pointer',
            fontWeight: 800, fontSize: 14,
          }}
        >
          <Icon name="route" size={14} color="#020617" />
          {t('help.replay')}
        </button>
      </div>
    </div>
  );
}
